export default "__VITE_ASSET__84b8f683__"